module.exports = __webpack_public_path__ + "assets/alerts_white.73d2d802.svg";